import { setAIQASize, setMainSizeFromAiQA } from "@/utils/window";
import { create } from "zustand";

interface AIQAState {
  isAIQAMode: boolean;
  mainRef?: React.RefObject<HTMLDivElement> | null;
}

interface AIQAStore extends AIQAState {
  toggleAIQAMode: (status?: boolean, needToggleWin?: boolean) => void;
  setMainRef: (ref: React.RefObject<HTMLDivElement>) => void;
}

const AIQAState: AIQAState = {
  isAIQAMode: false,
  mainRef: null,
};

const AIQAStore = create<AIQAStore>()((set, get) => ({
  ...AIQAState,
  toggleAIQAMode: async (status, needToggleWin = true) => {
    const isAIQAMode = get().isAIQAMode;
    const mode = status ?? !isAIQAMode;
    if (mode === isAIQAMode) return;
    const main = get().mainRef?.current;
    const { width, height } = main?.getBoundingClientRect() || { width: 0, height: 0 };
    main?.style.setProperty("width", `${width - 1}px`);
    main?.style.setProperty("height", `${height}px`);
    main?.style.setProperty("flex", "0 0 auto");
    if (mode) {
      needToggleWin && (await setAIQASize());
    } else {
      needToggleWin && (await setMainSizeFromAiQA());
    }
    set({ isAIQAMode: mode });
    main?.style.removeProperty("width");
    main?.style.removeProperty("height");
    main?.style.removeProperty("flex");
  },
  setMainRef: (ref) => {
    set({ mainRef: ref });
  },
}));

export default AIQAStore;
